import { useAppSelector } from '../reducers';
import { isUngatedForSeatsSelector, areGatesPopulatedSelector } from '../selectors/GatingSelectors';
import { gatesSelector } from '../selectors/SelectorUtils';
export const useShouldHideDataOrSuitePage = () => {
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const areGatesPopulated = useAppSelector(areGatesPopulatedSelector);
  const gates = useAppSelector(gatesSelector);
  if (!areGatesPopulated || gates.length === 0) {
    return false;
  }
  return !isUngatedForSeats;
};